/** "in 2h", "in 3d" — compact relative time for future timestamps ("overdue" when past). */
export function timeUntil(iso: string): string {
  const seconds = (new Date(iso).getTime() - Date.now()) / 1000;
  if (seconds <= 0) return 'overdue';
  if (seconds < 60) return 'in under a minute';
  const minutes = seconds / 60;
  if (minutes < 60) return `in ${Math.floor(minutes)}m`;
  const hours = minutes / 60;
  if (hours < 24) return `in ${Math.floor(hours)}h`;
  const days = hours / 24;
  if (days < 30) return `in ${Math.floor(days)}d`;
  return new Date(iso).toLocaleDateString();
}

/** "3m ago", "2h ago", "5d ago" — compact relative time for list rows. */
export function timeAgo(iso: string): string {
  const seconds = Math.max(0, (Date.now() - new Date(iso).getTime()) / 1000);
  if (seconds < 60) return 'just now';
  const minutes = seconds / 60;
  if (minutes < 60) return `${Math.floor(minutes)}m ago`;
  const hours = minutes / 60;
  if (hours < 24) return `${Math.floor(hours)}h ago`;
  const days = hours / 24;
  if (days < 30) return `${Math.floor(days)}d ago`;
  return new Date(iso).toLocaleDateString();
}
